export const MEASUREMENT_ID = 'G-BHMGK5VH5Y';
// A previous Google-only grant does not authorize a new analytics provider.
export const ANALYTICS_CONSENT_KEY = 'shule.analytics-consent.v2';
export const METRICOOL_SITE_ID = '84e193afce5afa4719a78c0d322efd31';
const KEY = ANALYTICS_CONSENT_KEY;
const ORIGIN = 'https://shuletaki.com.tr';
export function publicAnalyticsUrl(value) {
  let url;
  try { url = new URL(value, ORIGIN); } catch { return null; }
  if (!['https://shuletaki.com.tr', 'https://www.shuletaki.com.tr'].includes(url.origin) || url.username || url.password) return null;
  const path = url.pathname.replace(/\/+$/, '') || '/';
  if (!/^\/(?:|hakkimizda|magazalar|kiosklar|bayilik|hediye|shule-club|iletisim|gizlilik|veri-silme|kullanim-kosullari|mobil-uygulamalar|blog(?:\/[a-z0-9-]{1,100})?|kategori\/[a-z0-9-]{1,100}|urun\/[a-z0-9-]{1,100}|koleksiyon\/[a-z0-9-]{1,100})$/.test(path)) return null;
  return ORIGIN + path;
}

export function createAnalytics(win, doc) {
  let loaded = Boolean(doc.getElementById('shule-google-analytics')), consent = null, stopped = false;
  const disable = 'ga-disable-' + MEASUREMENT_ID;
  try {
    const value = win.localStorage.getItem(KEY);
    if (value === 'granted' || value === 'denied') consent = value;
    else if (win.localStorage.getItem('shule.analytics-consent.v1') === 'denied') consent = 'denied';
  } catch {}
  function command() { win.dataLayer.push(arguments); }
  function metricoolPage(safe) {
    if (win.__shuleMetricoolPage === safe) return;
    // Metricool's supplied be.js sends this pixel with the raw location/referrer.
    // Keep its wire format, but send only the canonical public URL and no referrer.
    // No third-party script/history listener can later observe a private SPA route.
    const pixel = doc.createElement('img');
    pixel.width = 1; pixel.height = 1; pixel.alt = '';
    pixel.referrerPolicy = 'no-referrer';
    const query = new URLSearchParams({hash:METRICOOL_SITE_ID, u:safe,
      bw:String(win.innerWidth || 0), bh:String(win.innerHeight || 0)});
    pixel.src = 'https://tracker.metricool.com/c3po.jpg?' + query.toString();
    win.__shuleMetricoolPixel = pixel;
    win.__shuleMetricoolPage = safe;
  }
  function refresh(value = win.location.href) {
    const safe = publicAnalyticsUrl(value);
    win[disable] = stopped || consent !== 'granted' || !safe;
    if (win[disable]) {
      if (!safe) win.__shuleMetricoolPage = null;
      return;
    }
    metricoolPage(safe);
    if (!loaded) {
      loaded = true;
      win.dataLayer = win.dataLayer || [];
      win.gtag = command;
      command('consent', 'default', {analytics_storage:'denied', ad_storage:'denied', ad_user_data:'denied', ad_personalization:'denied'});
      command('consent', 'update', {analytics_storage:'granted'});
      command('js', new Date());
      // Fixed public URL/title/referrer prevent query strings and account titles entering the tag.
      command('set', {page_location:safe, page_referrer:ORIGIN + '/', page_title:'Shule'});
      command('config', MEASUREMENT_ID, {allow_google_signals:false, allow_ad_personalization_signals:false});
      const script = doc.createElement('script');
      script.id = 'shule-google-analytics'; script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + MEASUREMENT_ID;
      doc.head.appendChild(script);
    } else command('set', {page_location:safe, page_referrer:ORIGIN + '/', page_title:'Shule'});
  }
  const originals = {};
  for (const name of ['pushState', 'replaceState']) {
    originals[name] = win.history[name];
    win.history[name] = function(...args) {
      // Pause before Google history listeners can observe a private destination.
      win[disable] = true;
      const result = originals[name].apply(this, args);
      refresh(); return result;
    };
  }
  const onPop = () => refresh();
  win.addEventListener('popstate', onPop);
  return {
    getConsent: () => consent,
    start: () => refresh(),
    choose(value) {
      if (!['granted','denied'].includes(value)) throw Error('Invalid analytics preference');
      consent = value;
      try { win.localStorage.setItem(KEY, value); } catch {}
      if (value === 'denied') {
        win[disable] = true;
        if (loaded) command('consent','update',{analytics_storage:'denied'});
        for (const cookie of doc.cookie.split(';')) {
          const name = cookie.trim().split('=')[0];
          if (/^_ga(?:_|$)/.test(name)) for (const domain of ['', ';domain=shuletaki.com.tr', ';domain=.shuletaki.com.tr', ';domain=www.shuletaki.com.tr'])
            doc.cookie = name + '=;Max-Age=0;path=/' + domain + ';SameSite=Lax;Secure';
        }
      } else {
        if (loaded) command('consent','update',{analytics_storage:'granted'});
        refresh();
      }
    },
    stop() {
      stopped = true; win[disable] = true;
      win.removeEventListener('popstate', onPop);
      for (const name of Object.keys(originals)) win.history[name] = originals[name];
    }
  };
}
